import { Loader } from 'rsuite';
import styled from 'styled-components';

export default styled(Loader)`
  margin: 20px;
  display: block;
  text-align: center;
`;
